import { Text, View } from "../base";

type OrganizationSettingsTabProps = {
  title: string;
  description?: string;
  count?: number;
  children: React.ReactNode;
  className?: string;
};

export const OrganizationSettingsTab = ({ title, description, count, children, className }: OrganizationSettingsTabProps) => {
  return (
    <View className={`flex flex-col ${className || ""}`}>
      <View className="flex flex-row items-center justify-between mb-3">
        <Text className="text-xs font-medium uppercase tracking-wider text-gray-400 dark:text-gray-500">
          {title}
          {count !== undefined && count > 0 ? ` (${count})` : ""}
        </Text>
      </View>
      {children}
    </View>
  );
};
